"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionVega = exports.getPositionDelta = exports.calculateOptionPrices3dSurface = exports.calculateOptionPrices = exports.RangeType = void 0;
const calculationsCore_1 = require("../calculationsCore");
const pnlCalculations_1 = require("../pnlCalculations");
const types_1 = require("../types");
const black76_1 = require("./black76");
__exportStar(require("./black76"), exports);
var RangeType;
(function (RangeType) {
    RangeType["UnderlyingRange"] = "UnderlyingRange";
    RangeType["TimeRange"] = "TimeRange";
    RangeType["VolatilityRange"] = "VolatilityRange";
    RangeType["StrikeRange"] = "StrikeRange";
})(RangeType = exports.RangeType || (exports.RangeType = {}));
const calculateOptionPrices = (F, K, volatility, T, r, config) => {
    let res = {};
    for (let rangeType of Object.values(RangeType)) {
        if (config[rangeType]) {
            let currentRangeRes = [];
            const currentRangeDomain = getDomain(config[rangeType]);
            for (let x of currentRangeDomain) {
                const f = rangeType === RangeType.UnderlyingRange ? x : F;
                const k = rangeType === RangeType.StrikeRange ? x : K;
                const v = rangeType === RangeType.VolatilityRange ? x : volatility;
                const t = rangeType === RangeType.TimeRange ? x : T;
                currentRangeRes.push((0, black76_1.black76)(f, k, v, t, r));
            }
            let rangeResult = {
                domain: currentRangeDomain,
                values: currentRangeRes,
            };
            res[rangeType] = rangeResult;
        }
    }
    return res;
};
exports.calculateOptionPrices = calculateOptionPrices;
const calculateOptionPrices3dSurface = (F, K, volatility, T, r, config1, config2) => {
    if (!isValidRange(config1.range) || !isValidRange(config2.range)) {
        throw new Error("Range is not valid");
    }
    const domain1 = getDomain(config1.range);
    const domain2 = getDomain(config2.range);
    let res = [];
    for (let x of domain1) {
        let yResults = [];
        for (const y of domain2) {
            const f = getArgument(RangeType.UnderlyingRange, F, config1.rangeType, config2.rangeType, x, y);
            const k = getArgument(RangeType.StrikeRange, K, config1.rangeType, config2.rangeType, x, y);
            const v = getArgument(RangeType.VolatilityRange, volatility, config1.rangeType, config2.rangeType, x, y);
            const t = getArgument(RangeType.TimeRange, T, config1.rangeType, config2.rangeType, x, y);
            const z = (0, black76_1.black76)(f, k, v, t, r);
            yResults.push(z);
        }
        res.push(yResults);
    }
    return {
        domain1,
        domain2,
        z: res,
    };
};
exports.calculateOptionPrices3dSurface = calculateOptionPrices3dSurface;
const getPositionDelta = (position, ticker, calculationTimestamp) => {
    const instrumentType = (0, calculationsCore_1.getInstrumentType)(position.instrument);
    if ((0, pnlCalculations_1.isFutureLikeInstrument)(position.instrument)) {
        return position.amountCurrency;
    }
    const { optionType, strike } = (0, calculationsCore_1.getOptionInstrumentProperties)(position.instrument);
    const T = (0, calculationsCore_1.getPositionTimeToExpiryFromInstrumentString)(position.instrument, calculationTimestamp);
    const bs = (0, black76_1.black76)(ticker.underlyingPrice, strike, ticker.volatility / 100, T, 0);
    return optionType === types_1.OptionType.CALL
        ? bs.deltaCall * position.amount
        : bs.deltaPut * position.amount;
};
exports.getPositionDelta = getPositionDelta;
const getPositionVega = (position, ticker, calculationTimestamp) => {
    if ((0, pnlCalculations_1.isFutureLikeInstrument)(position.instrument)) {
        return 0;
    }
    const { strike } = (0, calculationsCore_1.getOptionInstrumentProperties)(position.instrument);
    const T = (0, calculationsCore_1.getPositionTimeToExpiryFromInstrumentString)(position.instrument, calculationTimestamp);
    const bs = (0, black76_1.black76)(ticker.underlyingPrice, strike, ticker.volatility / 100, T, 0);
    return bs.vega * position.amount;
};
exports.getPositionVega = getPositionVega;
// ----------------------------------------- //
// ---------------- PRIVATE ---------------- //
// ----------------------------------------- //
const getDomain = (range) => {
    if (Array.isArray(range)) {
        return range;
    }
    let res = [];
    for (let i = range.start; i <= range.end; i += range.step) {
        res.push(i);
    }
    return res;
};
const getArgument = (parameterRange, argumentFromParent, rangeType1, rangeType2, x, y) => {
    if (parameterRange === rangeType1) {
        return x;
    }
    else if (parameterRange === rangeType2) {
        return y;
    }
    return argumentFromParent;
};
const isValidRange = (range) => {
    if (Array.isArray(range)) {
        if (range.length > 0) {
            return true;
        }
    }
    const rg = range;
    if (rg.step === 0) {
        return false;
    }
    if (rg.start === rg.end) {
        return false;
    }
    return true;
};
